import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import './components/modules/Modules.css';
import { AuthProvider } from './contexts/AuthContext';
import { ClientSessionProvider } from './contexts/ClientSessionContext';
import { LanguageProvider } from './i18n/LanguageContext';
import { AdsProvider } from './components/ads/Ads';
import LandingPage from './components/LandingPage';
import ModulesOverview from './components/ModulesOverview';
import ModulePage from './components/ModulePage';
import Header from './components/Header';
import { NotFoundPage } from './components/ErrorPages';
import { useSEO } from './hooks/useSEO';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import BlogList from './blog/BlogList';
import BlogArticle from './blog/BlogArticle';

// REVAMP: public, login-free. The marketing/cover landing page is the home
// route (`/`); the tools live under `/app` and `/module/:id`. Language is
// auto-detected from the browser (English / 繁體中文 / 简体中文).
const AppContent: React.FC = () => {
  useSEO();
  const { pathname } = useLocation();
  // The cover landing page has its own branding; don't stack the app Header on it.
  const showHeader = pathname !== '/';

  return (
    <div className="app">
      {showHeader && <Header />}
      <main className={showHeader ? 'main-content' : 'main-content-full'}>
        <Routes>
          {/* Cover landing page */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<ModulesOverview />} />
          <Route path="/module/:moduleId" element={<ModulePage />} />

          {/* Auth/profile routes retired in the public revamp. */}
          <Route path="/login" element={<Navigate to="/app" replace />} />
          <Route path="/profile" element={<Navigate to="/app" replace />} />

          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />

          {/* Blog: article index + one page per article */}
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <LanguageProvider>
        <AuthProvider>
          <ClientSessionProvider>
            <AdsProvider>
              <AppContent />
            </AdsProvider>
          </ClientSessionProvider>
        </AuthProvider>
      </LanguageProvider>
    </Router>
  );
};

export default App;
